module.exports = __webpack_public_path__ + "static/media/signage-indoor-img76.48145af7.jpg";